module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "prologue"
    }
  }, [_c('h1', [_vm._v("Prologue")]), _vm._v(" "), _c('p', [_vm._v("In Baghdad, he was Mirin, after the Farsi for death sigh, "), _c('em', [_vm._v("mirine mirin")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("He fled through a ventilation shaft in the bathroom stall of a vegetarian restaurant on Sadoon Street and into the night by the banks of the Tigris.")]), _vm._v(" "), _c('p', [_vm._v("In Belgrade, he went by Bakar, meaning red or copper, after his russet hair. On that occasion, late ’93, he stole a fedora and sports jacket from the cloakroom and walked out of the bar into a waiting cab.")]), _vm._v(" "), _c('p', [_vm._v("In Beirut, he had no name; referenced by a soft whistle and a gentle shake of the head. Just to speak of him was to invoke darkness. That day, an intense, sweaty chase through the souk at Al-Tawileh ended in a dead-end, soon filled with yelling stallholders.")]), _vm._v(" "), _c('p', [_vm._v("In Belfast, his home town, he was Tam Croall. Or The Technician.")]), _vm._v(" "), _c('p', [_vm._v("And that was just the Bs.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd6db54c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0005.vue
// module id = 81
// module chunks = 0